/**
 * useGovernorateName — resolver from governorateId → localized governorate name.
 *
 * Reuses the existing store governorates reference list (the same query the
 * Filters drawer uses) — React Query dedupes/caches it, so calling this in many
 * rows costs one request. No backend change: the order list item already carries
 * `governorateId`.
 */

import { useLocale } from "@/lib/i18n/intl";
import { useSellerStoreSlug } from "@/lib/routing/useSellerStoreSlug";
import { useGovernoratesQuery } from "@/modules/settings/services/useGovernoratesQuery";

export function useGovernorateName(): (id?: string | null) => string | null {
  const storeSlug = useSellerStoreSlug();
  const locale = useLocale();
  const { data } = useGovernoratesQuery({ storeSlug });

  return (id?: string | null): string | null => {
    if (!id || !data) return null;
    const gov = data.find((g) => g.id === id);
    if (!gov) return null;
    return locale === "ar" ? gov.nameAr : gov.nameEn || gov.nameAr;
  };
}
